<template>
  <HvhChart :visualization="visualization" height="100px" @chart-rendered="chartRendered" />
</template>

<script>
import 'echarts/lib/chart/graph';
import HvhChart from '../../components/charts/HvhChart.vue';
import { getAllChildrens } from '../../libraries/common';
export default {
  components: { HvhChart },
  props: ['deliveries'],
  data() {
    return {
      translator: {
        'In Order': 0,
        'In Production': 1,
        'In QC': 2,
        'In Transit': 3,
        'Delivered': 4,
      },
    };
  },
  computed: {
    visualization() {
      var current = this.deliveries.last();
      var currentOrder = this.translator[current.status];
      if (!current.effectiveDate)
        currentOrder -= 1;

      var deliveries = this.deliveries
        .reduce((acc, f) => {
          var statusPosition = this.translator[f.status];
          var dateStatus = Object.entries(this.translator)
            .filter(([key, value]) => value === statusPosition - 1)
            .map(([key, value]) => key)
            .first();

          if (dateStatus)
            acc[dateStatus] = f.effectiveDate && this.dateFormat(f.effectiveDate);
          return acc;
        }, {});

      var links = Object.entries(this.translator)
        .filter(([key, value]) => value < currentOrder)
        .map(([key, value]) => ({
          source: value,
          target: value + 1,
          label: {
            formatter: deliveries[key],
            show: deliveries[key],
            fontSize: 14,
          },
        }));

      return {
        animationDurationUpdate: 1500,
        animationEasingUpdate: 'quinticInOut',
        series: [
          {
            type: 'graph',
            layout: 'none',
            symbolSize: 10,
            roam: true,
            label: {
              show: true,
              position: 'bottom'
            },
            edgeSymbol: ['circle', 'arrow'],
            edgeSymbolSize: [4, 10],
            edgeLabel: {
              fontSize: 20
            },
            data: [
              ...Object.entries(this.translator)
                .sortBy(([key, value]) => value)
                .map(([key, value]) => ({ name: key, x: value * 100, y: 300 })),
              {
                name: 'Current',
                x: Math.min(currentOrder + 0.5, 4) * 100,
                y: 300,
                label: { show: false, },
                symbolSize: 0,
              },
            ],
            links: [
              ...links,
              {
                source: links.last()?.target || 0,
                target: 'Current',
                lineStyle: {
                  type: 'dashed',
                },
              },
            ],
            lineStyle: {
              opacity: 0.9,
              width: 2,
              curveness: 0
            }
          }
        ]
      };
    },
  },
  methods: {
    chartRendered() {
      getAllChildrens(this.$el)
        .forEach(el => {
          el.onwheel = event => {
            event.preventDefault();
            event.stopPropagation();
          }
        });
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisITMCustomerStatusChart'] = this;
  }
}
</script>

<style lang="scss" scoped>
</style>